import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  popStageList: [],
  isStagesLoading: false,
  isCreateNewStageInProgress: false,
  isStageLoading: false,
  isUpdateStageInProgress: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CROP_STAGES_SUCCESS:
    case actionTypes.GET_CROP_STAGES_ERROR:
      return Object.assign({}, state, action.payload);
    case actionTypes.GET_STAGE_ERROR:
    case actionTypes.GET_STAGE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_STAGES:
          return Object.assign({}, state, {isStagesLoading: true});
        case actionTypes.GET_STAGE:
          return Object.assign({}, state, {isStageLoading: true});
        case actionTypes.CREATE_CROP_STAGE:
          return Object.assign({}, state, {isCreateNewStageInProgress: true});
        case actionTypes.EDIT_STAGE:
          return Object.assign({}, state, {isUpdateStageInProgress: true});
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_STAGES:
          return Object.assign({}, state, {isStagesLoading: false});
        case actionTypes.GET_STAGE:
          return Object.assign({}, state, {isStageLoading: false});
        case actionTypes.CREATE_CROP_STAGE:
          return Object.assign({}, state, {isCreateNewStageInProgress: false});
        case actionTypes.EDIT_STAGE:
          return Object.assign({}, state, {isUpdateStageInProgress: false});
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
